export class ApiError extends Error {
  code: number;
  message: string;

  constructor(code: number, message: string) {
    super(message);
    this.code = code;
    this.message = message;
  }
}
export interface Pagination {
  currentPage: number;
  filteredPages: number | null;
  pageSize: number;
  processedCount: number;
  totalCount: number;
  totalPages: number;
}

export interface DocumentZipFilters {
  searchQuery?: string;
  processed?: boolean;
  extensions?: string[];
  startDate?: string;
  endDate?: string;
  documentTypes?: string[];
  documentThemes?: string[];
  hasKeyFacts?: boolean;
  hasRelevantFacts?: boolean;
}

export enum QueryEntity {
  ActiveRuns,
  ApideckAllConnections,
  AllCaseDocs,
  ApideckSession,
  Case,
  Cases,
  CaseDocs,
  CaseFacts,
  CaseInconsistencies,
  CaseIsPendingUpload,
  CaseOverview,
  Chronologies,
  Chronology,
  ChronologyFacts,
  ChronologyVisualisation,
  Chunk,
  Doc,
  DocIds,
  DocSubsets,
  DocTypes,
  DocThemes,
  DocTotals,
  DocUnzip,
  DocumentChunkMatches,
  DraftCases,
  Fact,
  Files,
  IncludedFactsCount,
  InconsistencyReport,
  InconsistencyReports,
  KeyFacts,
  Matters,
  MatterUsers,
  Messages,
  Organisation,
  OrganisationById,
  OrgUsageData,
  PersonalMatter,
  Persons,
  PresignedGetDocumentImage,
  PresignedGetDocumentPDF,
  PresignedPost,
  RecentCases,
  RelativityDocumentCount,
  RelativityLists,
  RelativityWorkspaces,
  Roles,
  Summary,
  CaseThemes,
  Threads,
  ThreadStatus,
  PublishedThreads,
  Transcript,
  TranscriptAudio,
  TranscriptInconsistencies,
  TranscriptSubfact,
  Transcripts,
  UploadPagesEstimate,
  UploadHistory,
  UserRoles,
  Users,
  UsersPaginated,
  User,
}
